import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesArchiveBooks2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 27.43h-6.09V1.52h6.09V0H4.58v1.52h18.28v7.62h-4.57v1.53h4.57v4.57h-1.52v1.52h-3.05v-1.52h-1.52v1.52H12.2v-3.04h-1.53v3.04H3.05v-3.04H1.53v3.04H0v10.67h1.53v-9.14h13.71v9.14H1.53v1.52h1.52V32h1.53v-3.05h18.28V32h1.53v-3.05h6.09V32H32V1.52h-1.52z\"/><path fill=\"currentColor\" d=\"M10.67 4.57h6.1V6.1h-6.1ZM6.1 21.33h4.57v1.53H6.1ZM3.05 1.52h1.53v6.1H3.05Zm6.1 9.15v3.05h1.52v-1.53h4.57v3.05h1.53v-1.52h3.04v1.52h1.53v-3.05h-4.57v-1.52h-6.1V9.14H0v4.58h1.53v-3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesArchiveBooks2
